// extracted by mini-css-extract-plugin
export default {"collapseContainer":"AudioCollapseSection_collapseContainer__dwC4Y"};